import { useAppSettings } from '../providers/AppSettingsProvider';

export function useLanguage() {
  const { currentLanguage, switchLanguage, t } = useAppSettings();

  return {
    currentLanguage,
    currentLang: currentLanguage,
    switchLanguage,
    setLanguage: switchLanguage,
    t,
  };
}
